interface GenerateDisputeNotesDTOProps {
  checkNumber: string;
  invoiceNumber: string;
  deductionAmount: number;
  purchaser: string;
  disputeType: string;
  disputeAmount: number;
  noteTemplate?: string | null;
  reasonCode?: string | null;
  rcaDescription?: string | null;
  deductionType?: string | null;
  poNumber?: string | null;
  deductionDate?: string | null;
  invoiceDate?: string | null;
  brandName?: string | null;
}

export class GenerateDisputeNotesDTO {
  readonly checkNumber: string;
  readonly invoiceNumber: string;
  readonly deductionAmount: number;
  readonly purchaser: string;
  readonly disputeType: string;
  readonly disputeAmount: number;
  readonly noteTemplate?: string | null;
  readonly reasonCode?: string | null;
  readonly rcaDescription?: string | null;
  readonly deductionType?: string | null;
  readonly poNumber?: string | null;
  readonly deductionDate?: string | null;
  readonly invoiceDate?: string | null;
  readonly brandName?: string | null;

  constructor(data: GenerateDisputeNotesDTOProps) {
    this.checkNumber = data.checkNumber;
    this.invoiceNumber = data.invoiceNumber;
    this.deductionAmount = data.deductionAmount;
    this.purchaser = data.purchaser;
    this.disputeType = data.disputeType;
    this.disputeAmount = data.disputeAmount;
    this.noteTemplate = data.noteTemplate;
    this.reasonCode = data.reasonCode;
    this.rcaDescription = data.rcaDescription;
    this.deductionType = data.deductionType;
    this.poNumber = data.poNumber;
    this.deductionDate = data.deductionDate;
    this.invoiceDate = data.invoiceDate;
    this.brandName = data.brandName;
  }
}
